import { gql } from '@apollo/client';

import { OutcomesFragment } from 'approot/shared/graphql/outcomes/outcomes.graphql';
import { LessonMaterialFragment } from 'approot/shared/lesson-materials/lesson-material-fragment';
import { ActivityOutcomesFragment } from './key-activity-information/activity-outcomes.graphql';

export const teachingAndLearningSequenceFragment = gql`
  fragment TeachingLearningSequenceFragment on ActivitiesTeachingLearningSequenceItem {
    id
    category
    data
    activityOutcomes {
      ...ActivityOutcomesFragment
    }
    component {
      id
      properties {
        activitySettings {
          differentiation
          duration
          checkPoint
          furtherEnrichment
        }
        aiRationale {
          curriculum
          cognitiveQuestionType
          context
        }
      }
      sectionId
    }
    lessonMaterials {
      ...LessonMaterialFragment
    }
    theEsDetails {
      id
      name
      link
    }
    visibleThinkingActivitiesDetails {
      id
      name
      link
    }
    highImpactTeachingStrategiesDetails {
      id
      name
      link
    }
    sectionId
    sort
    type
    connections {
      subject
      outcomes {
        ...OutcomesFragment
        description
        type
      }
    }
  }
  ${OutcomesFragment}
  ${LessonMaterialFragment}
  ${ActivityOutcomesFragment}
`;

export const GET_LESSON_TEACHING_LEARNING_SEQUENCE = gql`
  query GetLessonTeachingAndLearningSequence(
    $input: GetTeachingAndLearningSequenceInput!
  ) {
    getLessonTeachingAndLearningSequence(input: $input) {
      ...TeachingLearningSequenceFragment
    }
  }
  ${teachingAndLearningSequenceFragment}
`;

export const UPDATE_TEACHING_LEARNING_SEQUENCE_ITEM = gql`
  mutation UpdateInteractiveTeachingLearningSequenceItem(
    $input: UpdateTeachingLearningSequenceItemInput!
  ) {
    updateTeachingLearningSequenceItem(input: $input) {
      ...TeachingLearningSequenceFragment
    }
  }
  ${teachingAndLearningSequenceFragment}
`;

export const INSERT_TEACHING_LEARNING_SEQUENCE_ITEM = gql`
  mutation InsertTeachingLearningSequenceItem(
    $input: InsertTeachingLearningSequenceItemInput!
  ) {
    insertTeachingLearningSequenceItem(input: $input) {
      ...TeachingLearningSequenceFragment
    }
  }
  ${teachingAndLearningSequenceFragment}
`;

export const DELETE_TEACHING_LEARNING_SEQUENCE_ITEM = gql`
  mutation DeleteTeachingLearningSequenceItem(
    $input: DeleteTeachingLearningSequenceItemInput!
  ) {
    deleteTeachingLearningSequenceItem(input: $input)
  }
`;

export const GET_ALL_DEFINED_TEACHING_AND_LEARNING_STRATEGIES = gql`
  query GetAllDefinedTeachingAndLearningStrategies {
    getAllDefinedTeachingAndLearningStrategies {
      theEs {
        id
        name
        link
      }
      visibleThinkingActivities {
        id
        name
        link
      }
      highImpactTeachingStrategies {
        id
        name
        link
      }
    }
  }
`;
